import { render, staticRenderFns } from "./ModalAddVoice.vue?vue&type=template&id=d1c38740&scoped=true&"
import script from "./ModalAddVoice.vue?vue&type=script&lang=js&"
export * from "./ModalAddVoice.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddVoice.vue?vue&type=style&index=0&id=d1c38740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c38740",
  null
  
)

export default component.exports